<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPage
          :data="page"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          :language="language"
          @delete-page="deletePage"
          @language-update="language = $event"
          @submit="formPageSubmit"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormPage from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import createPage from '@/services/gql/types/Pages/mutations/createPage.gql'
import deletePage from '@/services/gql/types/Pages/mutations/deletePage.gql'
import updatePage from '@/services/gql/types/Pages/mutations/updatePage.gql'
import pageQuery from '@/services/gql/types/Pages/queries/page.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'Page',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormPage,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать страницу' : 'Создать страницу'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      page: {}
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.page.loading
    },
    isMutationLoading () {
      return this.$async.createPage.$pending || this.$async.updatePage.$pending
    }
  },
  methods: {
    async formPageSubmit (pagePayLoad) {
      if (!this.id) await this.createPage(pagePayLoad)
      else await this.updatePage(pagePayLoad)
    },
    async deletePage () {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deletePage.$perform({ id: Number(this.id) })
        this.$successMsg('Страница удалена')
      } catch (e) {
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении страницы с ID ${this.id}`
        )
      } finally {
        await this.$router.push({ name: 'page-pages' })
      }
    },
    async updatePage ({ data }) {
      try {
        setTranslation(data, this.language)
        await this.$async.updatePage.$perform(
          {
            updatePageId: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Страница изменена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании страницы')
      }
    },
    async createPage ({ data }) {
      delete data.translations
      try {
        await this.$async.createPage.$perform({
          data
        })
        this.$successMsg('Страница создана')
        await this.$router.push({ name: 'page-pages' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании страницы')
      }
    }
  },
  apollo: {
    page: {
      query: pageQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      }
    }
  },
  async: {
    createPage (variables) {
      return this.$apollo.mutate({
        mutation: createPage,
        variables
      })
    },
    deletePage (variables) {
      return this.$apollo.mutate({
        mutation: deletePage,
        variables
      })
    },
    updatePage (variables, headers) {
      return this.$apollo.mutate({
        mutation: updatePage,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
